<!-- 数据需求方 / 数据服务商 / 数据集 -->
<template>
  <div class="ds-page" :class="{ 'is-dataset': isDataset, 'is-provider': isProvider }">
    <div class="gs-page-hero">
      <div class="gs-hero-art" :class="{ 'is-dataset': isDataset, 'is-provider': isProvider, 'is-demand': isDemand }" aria-hidden="true"></div>
      <div class="gs-page-hero-inner">
        <div>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSub }}</p>
        </div>
      </div>
      <div class="gs-page-hero-metrics">
        <template v-if="isDataset">
          <div v-for="item in heroStats" :key="item.label" class="gs-page-hero-metric">
            <div class="metric-num"><em>{{ item.value }}</em>{{ item.unit }}</div>
            <div class="metric-label">{{ item.label }}</div>
          </div>
        </template>
        <div v-else class="gs-page-hero-metric">
          <div class="metric-num"><em>{{ total }}</em>条</div>
          <div class="metric-label">供需入驻</div>
        </div>
      </div>
    </div>

    <div v-if="businessPilotEnabled && isDataset" class="business-entry">
      <el-button type="primary" @click="$router.push('/datasets/register')">登记数据集并初评</el-button>
      <el-button @click="$router.push('/demand/assistant')">按采购需求找数据</el-button>
      <el-button @click="$router.push('/datasets/collection-plan')">企业数据采集规划</el-button>
    </div>
    <div class="search-form">
      <div class="ds-search">
        <input
          v-model="queryFrom.keySearch"
          class="ds-search-input"
          type="text"
          :placeholder="searchPlaceholder"
          @keyup.enter="clickBtn"
        >
        <button type="button" class="ds-search-btn" @click="clickBtn">数据查一下</button>
      </div>
      <button
        v-if="isNarrow && (isDataset || labelList.length)"
        type="button"
        class="ds-filter-toggle"
        @click="filtersOpen = !filtersOpen"
      >{{ filtersOpen ? '收起筛选' : '展开筛选' }}</button>
      <div class="ds-filters" :class="{ 'is-collapsed': isNarrow && !filtersOpen }">
      <div v-if="isDataset" class="filter-line">
        <span class="filter-label">数据时效</span>
        <div class="filter-row">
          <span class="filter-chip" :class="{ 'is-active': !queryFrom.dataAging }" @click="setAging('')">全部</span>
          <span
            v-for="item in dataAgingEnum"
            :key="item.value"
            class="filter-chip"
            :class="{ 'is-active': queryFrom.dataAging === item.value }"
            @click="setAging(item.value)"
          >{{ item.label }}</span>
        </div>
      </div>
      <div v-if="labelList.length" class="filter-line">
        <span class="filter-label">{{ isDataset ? '应用场景' : '高频标签' }}</span>
        <div class="filter-row">
          <span class="filter-chip filter-tag" :class="{ 'is-active': !queryFrom.hotTag }" @click="setHotTag('')">全部</span>
          <span
            v-for="item in visibleTags"
            :key="item.value"
            class="filter-chip filter-tag"
            :class="{ 'is-active': queryFrom.hotTag === item.value }"
            @click="setHotTag(item.value)"
          >{{ item.label }}</span>
        </div>
        <button v-if="labelList.length > 8" type="button" class="filter-expand" @click="tagsExpanded = !tagsExpanded">
          {{ tagsExpanded ? '收起' : '展开' }}
        </button>
      </div>
      </div>
    </div>

    <div v-loading="loading" class="ds-table-wrap">
      <div class="ds-table">
        <div class="ds-head">
          <span class="c-name">{{ isDataset ? '数据集名称' : '入驻名称' }}</span>
          <span v-if="isDataset" class="c-company">公司名称</span>
          <span class="c-desc">{{ descLabel }}</span>
          <span class="c-num">{{ numLabel }}</span>
          <span class="c-addr">{{ isDataset ? '所属行业' : '联系地址' }}</span>
          <span class="c-act">操作</span>
        </div>
        <div v-if="tableData && tableData.length" class="ds-body">
          <div v-for="row in tableData" :key="rowKey(row)" class="ds-row-item">
            <span class="c-name" :title="rowName(row)">{{ rowName(row) }}</span>
            <span v-if="isDataset" class="c-company" :title="row.enterpriseName || ''">{{ (row && row.enterpriseName) || '—' }}</span>
            <span class="c-desc" :title="rowDesc(row)"><em class="ds-k">{{ descLabel }}</em>{{ rowDesc(row) }}</span>
            <span class="c-num"><em class="ds-k">{{ numLabel }}</em>{{ rowNum(row) }}</span>
            <span class="c-addr" :title="rowAddr(row)"><em class="ds-k">{{ addrLabel }}</em>{{ rowAddr(row) }}</span>
            <span class="c-act">
              <button type="button" class="ds-link" @click="detailRow(row)">详情</button>
            </span>
          </div>
        </div>
        <div v-else class="ds-empty">暂无数据</div>
      </div>
      <div class="table-pagination">
        <GsPagination
          :current-page="currentPage"
          :page-size="pageSize"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <DataRequirementRequestView
      :showDialog="showDialog"
      :enterpriseId="enterpriseId"
      :companyId="companyId"
      :dialogTitle="dialogTitle"
      @closeDetailDialog="closeDetailDialog"
      :data-type="String(pageType)"
    />
  </div>
</template>
<script>
import { applicationScenario, getDatasetList } from '@/api/api.js'
import { getListingList } from '@/api/Home/index.js'
import { getDataType as getDictType } from '@/api/Layout/index.js'
import { enumType } from '@/utils/enum.js'
import DataRequirementRequestView from '@/views/Home/components/dataInfo/DataRequirementRequestView.vue'
import GsPagination from '@/components/GsPagination/index.vue'
import { P } from '@/router/paths'
import { businessPilotEnabled } from '@/config/business'

export default {
  name: 'DataDemandSide',
  components: {
    DataRequirementRequestView,
    GsPagination
  },
  data() {
    return {
      businessPilotEnabled,
      total: 0,
      currentPage: 1,
      pageSize: 20,
      loading: false,
      enterpriseId: '',
      companyId: '',
      queryFrom: {
        keySearch: '',
        dataAging: '',
        hotTag: ''
      },
      showDialog: false,
      labelList: [],
      tableData: [],
      heroStats: [
        { label: '已挂牌数据集', value: '-', unit: '条' },
        { label: '关联企业', value: '-', unit: '家' },
        { label: '覆盖地区', value: '-', unit: '个' },
        { label: '有内容简介', value: '-', unit: '条' },
        { label: '有应用场景', value: '-', unit: '条' },
        { label: '有封面', value: '-', unit: '条' }
      ],
      dataAgingEnum: [],
      dialogTitle: '',
      tagsExpanded: false,
      filtersOpen: false,
      isNarrow: typeof window !== 'undefined' && window.innerWidth < 960
    }
  },
  computed: {
    pageType() {
      return Number(this.$route.meta && this.$route.meta.listType) || 0
    },
    isDataset() {
      return this.pageType === 3
    },
    isProvider() {
      return this.pageType === 2 && !this.isDataset
    },
    isDemand() {
      return this.pageType === 1
    },
    pageTitle() {
      if (this.isDataset) return '数据集'
      if (this.isProvider) return '数据服务商'
      return this.isProvider ? '数据服务商' : '数据需求方'
    },
    pageSub() {
      if (this.isDataset) return '按时效与应用场景检索已公开登记的数据集档案'
      if (this.isProvider) return '查找已入驻的数据服务商展示卡'
      return '查找已入驻的数据需求方展示卡'
    },
    searchPlaceholder() {
      if (this.isDataset) return '搜索数据集名称、简介或登记主体'
      if (this.isProvider) return '搜索服务商名称、产品或服务内容'
      return '搜索需求方名称或需求描述'
    },
    descLabel() {
      if (this.isDataset) return '内容简介'
      return this.pageType === 1 ? '数据需求描述' : '数据服务内容描述'
    },
    numLabel() {
      if (this.isDataset) return '行政区划'
      return this.pageType === 1 ? '数据需求量' : '行业类型'
    },
    addrLabel() {
      return this.isDataset ? '所属行业' : '联系地址'
    },
    visibleTags() {
      if (this.tagsExpanded || this.labelList.length <= 8) return this.labelList
      return this.labelList.slice(0, 8)
    }
  },
  watch: {
    '$route.path'() {
      this.resetQuery()
    }
  },
  mounted() {
    this.syncNarrow()
    window.addEventListener('resize', this.syncNarrow)
    window.scrollTo(0, 0)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.syncNarrow)
  },
  created() {
    this.loadFilters()
    this.initData()
    if (this.isDataset) this.loadHeroStats()
  },
  methods: {
    syncNarrow() {
      this.isNarrow = typeof window !== 'undefined' && window.innerWidth < 960
      if (!this.isNarrow) this.filtersOpen = false
    },
    resetQuery() {
      this.currentPage = 1
      this.queryFrom = { keySearch: '', dataAging: '', hotTag: '' }
      this.tagsExpanded = false
      this.loadFilters()
      this.initData()
      if (this.isDataset) this.loadHeroStats()
    },
    clickBtn() {
      this.currentPage = 1
      this.initData()
    },
    setAging(value) {
      this.queryFrom.dataAging = value || ''
      this.currentPage = 1
      this.initData()
    },
    setHotTag(value) {
      const next = value || ''
      this.queryFrom.hotTag = this.queryFrom.hotTag === next ? '' : next
      this.currentPage = 1
      this.initData()
    },
    loadFilters() {
      if (this.isDataset) {
        this.getDict('sys_data_aging')
        this.loadScenes()
      } else {
        this.getDict('sys_business_type')
      }
    },
    async getDict(type) {
      try {
        const res = await getDictType(type)
        if (res && res.data && res.data.length > 0) {
          if (type === 'sys_business_type') this.labelList = enumType(res.data)
          if (type === 'sys_data_aging') this.dataAgingEnum = enumType(res.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    },
    loadScenes() {
      applicationScenario().then((res) => {
        const list = (res && res.data) || []
        this.labelList = list.map((item) => ({
          value: item.value || item.code || item.id,
          label: item.label || item.name
        })).filter((item) => item.value && item.label)
      }).catch(() => {
        this.labelList = []
      })
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.initData()
    },
    loadHeroStats() {
      getDatasetList({ pageNum: 1, pageSize: 200, whetherPublish: '1' }).then((res) => {
        const rows = (res && res.rows) || []
        const total = (res && res.total) || rows.length
        const regions = new Set()
        const enterprises = new Set()
        let intro = 0
        let scene = 0
        let cover = 0
        rows.forEach((row) => {
          const region = row && (row.administrativeDivisionName || row.registeredAddressName)
          if (region) regions.add(region)
          if (row && row.enterpriseId) enterprises.add(row.enterpriseId)
          if (row && row.dataContentIntroduction) intro += 1
          if (row && (row.dataApplicationScenarios || row.applicationScenario)) scene += 1
          if (row && row.coverPicture) cover += 1
        })
        this.heroStats = [
          { label: '已挂牌数据集', value: total, unit: '条' },
          { label: '关联企业', value: enterprises.size, unit: '家' },
          { label: '覆盖地区', value: regions.size, unit: '个' },
          { label: '有内容简介', value: intro, unit: '条' },
          { label: '有应用场景', value: scene, unit: '条' },
          { label: '有封面', value: cover, unit: '条' }
        ]
      }).catch(() => {})
    },
    initData() {
      this.loading = true
      const req = this.isDataset ? this.loadDataset() : this.loadCompany()
      req.then((res) => {
        this.loading = false
        this.tableData = (res && res.rows) || []
        this.total = (res && res.total) || 0
      }).catch(() => {
        this.loading = false
      })
    },
    loadCompany() {
      return getListingList({
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        pageNum: this.currentPage,
        keySearch: this.queryFrom.keySearch || null,
        dataAging: this.queryFrom.dataAging || null,
        businessType: this.queryFrom.hotTag || null,
        whetherPublish: '1',
        listingType: this.pageType === 1 ? '6' : '5'
      })
    },
    loadDataset() {
      return getDatasetList({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        whetherPublish: '1',
        keySearch: this.queryFrom.keySearch || null,
        dataAging: this.queryFrom.dataAging || null,
        dataApplicationScenarios: this.queryFrom.hotTag || null
      })
    },
    labelText(value) {
      if (!value) return '-'
      const hit = (this.labelList || []).find((item) => String(item.value) === String(value))
      return (hit && hit.label) || value
    },
    rowKey(row) {
      return row.id || row.enterpriseId || row.companyName || row.enterpriseName
    },
    rowName(row) {
      if (this.isDataset) return row.registrationDataName || '-'
      return row.companyName || '-'
    },
    rowDesc(row) {
      if (this.isDataset) return row.dataContentIntroduction || row.registrationDataName || '暂无简介'
      return row.requireMent || row.dataRequirement || '暂无简介'
    },
    rowNum(row) {
      if (this.isDataset) return row.administrativeDivisionName || row.registeredAddressName || '-'
      if (this.pageType === 1) return row.dataRequirement || row.dataQuantity || '-'
      return this.labelText(row.businessType)
    },
    rowAddr(row) {
      if (this.isDataset) return row.industryName || row.registrationDataTypeName || row.registrationDataType || '-'
      return row.address || '-'
    },
    detailRow(row) {
      this.enterpriseId = row.enterpriseId || row.id
      this.companyId = row.id
      if (this.isDataset) {
        this.$router.push(P.datasetDetail(row.id))
        return
      }
      this.$router.push(P.listingDetail(row.id, this.pageType === 1 ? 'demand' : 'provider'))
    },
    closeDetailDialog(data) {
      this.showDialog = data
    }
  }
}
</script>
<style lang="css" scoped>
.ds-page {
  width: 100%;
  box-sizing: border-box;
  padding: 0 0 32px;
  color: #1d2b44;
  overflow: visible;
}
.ds-page .gs-page-hero {
  margin-bottom: 18px;
}
.search-form {
  width: min(var(--gs-main-width, 1250px), 100%);
  margin: 0 auto 18px;
  background: #F2F6FB;
  border: 0;
  border-radius: 12px;
  padding: 16px 20px 10px;
  box-sizing: border-box;
}
.ds-search {
  display: flex;
  width: 100%;
  margin-bottom: 10px;
}
.ds-search-input {
  flex: 1 1 auto;
  width: 100%;
  min-width: 0;
  height: 40px;
  border: 1px solid #D7DEE8;
  border-right: 0;
  border-radius: 4px 0 0 4px;
  padding: 0 14px;
  outline: none;
  background: #fff;
  font-family: inherit;
  font-size: 14px;
  color: #1f2937;
}
.ds-search-input::placeholder {
  font-family: inherit;
  font-size: 14px;
  color: #8A96A8;
}
.ds-search-input:focus {
  border-color: #0165FF;
}
.ds-search-btn {
  flex: 0 0 auto;
  height: 40px;
  padding: 0 18px;
  border: 0;
  border-radius: 0 4px 4px 0;
  background: linear-gradient(180deg, #9CC8FF 0%, #4D94FF 42%, #0165FF 86%, #0050CC 100%);
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  white-space: nowrap;
  box-shadow: inset 0 1px 0 rgba(255,255,255,0.45);
}
.filter-line {
  display: flex;
  align-items: center;
  gap: 10px 16px;
  padding: 7px 0;
  max-width: 100%;
  min-width: 0;
}
.filter-label {
  flex: 0 0 72px;
  color: #333;
  font-size: 14px;
  line-height: 32px;
  white-space: nowrap;
}
.filter-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
  flex: 1;
  min-width: 0;
}
.filter-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 28px;
  padding: 0 12px;
  border-radius: 4px;
  color: #333;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
  line-height: 1;
  background: transparent;
}
.filter-chip.is-active {
  color: #fff;
  background: linear-gradient(180deg, #9CC8FF 0%, #4D94FF 42%, #0165FF 86%, #0050CC 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.55),
    inset 0 -1px 0 rgba(0, 50, 140, 0.22),
    0 3px 8px rgba(1, 101, 255, 0.32);
}
.filter-chip.filter-tag {
  min-width: 84px;
  height: 30px;
  border-radius: 15px;
  background: #D7E6FF;
  color: #0165FF;
}
.filter-chip.filter-tag.is-active {
  color: #fff;
  background: linear-gradient(180deg, #9CC8FF 0%, #4D94FF 42%, #0165FF 86%, #0050CC 100%);
  box-shadow:
    inset 0 1px 0 rgba(255, 255, 255, 0.55),
    inset 0 -1px 0 rgba(0, 50, 140, 0.22),
    0 3px 8px rgba(1, 101, 255, 0.32);
}
.filter-expand {
  margin-left: auto;
  flex: 0 0 auto;
  border: 0;
  background: transparent;
  color: #0165FF;
  font-size: 14px;
  cursor: pointer;
  padding: 0 4px;
}
.ds-k {
  display: none;
}
.ds-table-wrap {
  width: min(var(--gs-main-width, 1250px), 100%);
  margin: 0 auto;
  background: #fff;
  border-radius: 14px;
  padding: 0 0 8px;
  box-sizing: border-box;
}
.ds-table {
  width: 100%;
  background: #fff;
  border: 1px solid #D7E6FF;
  border-radius: 12px;
  overflow: hidden;
}
.ds-head,
.ds-row-item {
  display: grid;
  grid-template-columns: 1.6fr 2fr 1fr 1.3fr 88px;
  gap: 10px;
  align-items: center;
  padding: 0 18px;
}
.ds-page.is-dataset .ds-head,
.ds-page.is-dataset .ds-row-item {
  grid-template-columns: 1.6fr 1.6fr 2.2fr 0.9fr 1.1fr 80px;
}
.ds-head {
  height: 54px;
  background: linear-gradient(180deg, #EAF3FF 0%, #D7E6FF 100%);
  color: #0165FF;
  font-size: 15px;
  font-weight: 700;
}
.ds-row-item {
  min-height: 68px;
  border-top: 1px solid #EEF3F8;
  font-size: 15px;
  color: #334155;
}
.ds-row-item:nth-child(even) {
  background: #F8FBFF;
}
.ds-row-item:hover {
  background: #EEF5FF;
}
.c-name {
  font-size: 16px;
  font-weight: 700;
  color: #0B1F3A;
}
.c-name,
.c-desc,
.c-addr,
.c-mail {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.c-num,
.c-phone {
  color: #4A5B73;
}
.ds-empty {
  padding: 56px 0;
  text-align: center;
  color: #94a3b8;
  font-size: 15px;
}
.ds-link {
  height: 32px;
  padding: 0 14px;
  border: 0;
  border-radius: 6px;
  background: #0165FF;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
  font-weight: 700;
}
.ds-link:hover {
  background: #0050CC;
}
.table-pagination {
  margin-top: 16px;
}
@media (max-width: 960px) {
  .ds-page .gs-page-hero {
    margin-bottom: 12px;
  }
  .ds-page {
    overflow: visible;
    padding-bottom: 24px;
  }
  .search-form,
  .ds-table-wrap {
    width: calc(100% - 24px);
  }
  .search-form {
    padding: 12px 8px 6px;
    margin-bottom: 12px;
  }
  .ds-search {
    margin-bottom: 8px;
  }
  .ds-search-input,
  .ds-search-btn {
    height: 38px;
    font-size: 14px;
  }
  .ds-search-btn {
    padding: 0 12px;
  }
  .ds-filter-toggle {
    display: block;
    width: 100%;
    height: 32px;
    margin: 0 0 8px;
    border: 1px dashed #B8C9E0;
    border-radius: 6px;
    background: #fff;
    color: #0165FF;
    font-size: 13px;
    font-family: inherit;
    cursor: pointer;
  }
  .ds-filters.is-collapsed {
    display: none;
  }
  .filter-line {
    align-items: flex-start;
    gap: 8px 10px;
    padding: 6px 0;
  }
  .filter-label {
    flex: 0 0 64px;
    line-height: 28px;
    font-size: 13px;
  }
  .filter-row {
    gap: 6px 8px;
  }
  .filter-chip {
    min-width: 0;
    height: 28px;
    padding: 0 10px;
    font-size: 13px;
  }
  .filter-chip.filter-tag {
    min-width: 0;
    height: 28px;
    padding: 0 10px;
    font-size: 13px;
  }
  .filter-expand {
    margin-left: 0;
    padding: 4px 0 0;
  }
  .ds-table-wrap {
    background: transparent;
    border-radius: 0;
    padding: 0;
  }
  .ds-table {
    border: 0;
    background: transparent;
    overflow: visible;
  }
  .ds-head { display: none; }
  .ds-body {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .ds-row-item,
  .ds-page.is-dataset .ds-row-item {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 8px;
    min-height: 0;
    padding: 14px 14px 12px;
    background: #fff;
    border: 1px solid #E4E7ED;
    border-radius: 10px;
    border-top: 1px solid #E4E7ED;
    white-space: normal;
  }
  .ds-row-item:nth-child(even) {
    background: #fff;
  }
  .c-company {
    min-width: 0;
    color: #5E6166;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .c-name {
    font-size: 15px;
    line-height: 1.35;
    white-space: normal;
  }
  .c-desc,
  .c-addr,
  .c-mail {
    white-space: normal;
    font-size: 12px;
    line-height: 1.45;
    color: #4A5B73;
  }
  .c-desc {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .c-num,
  .c-addr {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 14px;
    color: #4A5B73;
  }
  .ds-k {
    display: inline-block;
    flex: 0 0 auto;
    min-width: 64px;
    color: #94a3b8;
    font-size: 13px;
    font-style: normal;
    font-weight: 500;
  }
  .c-act {
    display: flex;
    justify-content: flex-end;
    padding-top: 4px;
  }
  .ds-link {
    height: 34px;
    padding: 0 18px;
  }
  .ds-empty {
    background: #fff;
    border-radius: 10px;
  }
}
</style>
